var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBtnBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 9,
    viewBox: "0 0 19 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_61_4248",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 10
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.000244141,
    width: 18,
    height: 9,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_61_4248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.499999 0.000245714C0.499999 1.18214 0.732791 2.35247 1.18508 3.4444C1.63738 4.53633 2.30031 5.52848 3.13604 6.36421C3.97177 7.19993 4.96392 7.86287 6.05585 8.31516C7.14778 8.76745 8.3181 9.00025 9.5 9.00024C10.6819 9.00024 11.8522 8.76745 12.9442 8.31516C14.0361 7.86287 15.0282 7.19993 15.864 6.3642C16.6997 5.52848 17.3626 4.53633 17.8149 3.44439C18.2672 2.35246 18.5 1.18214 18.5 0.000243187L9.5 0.000244927L0.499999 0.000245714Z",
    fill: "#ccecdb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 0.000245539C1.5 1.05082 1.70693 2.09111 2.10896 3.06171C2.511 4.03232 3.10028 4.91423 3.84315 5.6571C4.58601 6.39997 5.46793 6.98924 6.43853 7.39128C7.40914 7.79332 8.44943 8.00024 9.5 8.00024C10.5506 8.00024 11.5909 7.79332 12.5615 7.39128C13.5321 6.98924 14.414 6.39997 15.1569 5.6571C15.8997 4.91423 16.489 4.03232 16.891 3.06171C17.2931 2.09111 17.5 1.05082 17.5 0.000243187L9.5 0.00024484L1.5 0.000245539Z",
    fill: "#80d0a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 0.000245365C2.5 1.85676 3.2375 3.63724 4.55025 4.94999C5.86301 6.26275 7.64348 7.00024 9.5 7.00024C11.3565 7.00024 13.137 6.26275 14.4497 4.94999C15.7625 3.63724 16.5 1.85676 16.5 0.000245094L9.5 0.000244753L2.5 0.000245365Z",
    fill: "#00A14B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnBg);
export default __webpack_public_path__ + "static/media/btn-bg.f9c7c3c0dbaecef0e50b8691aa595bd9.svg";
export { ForwardRef as ReactComponent };